module.exports = __webpack_public_path__ + "img/cmcc.b6f02d83.svg";